module.exports = __webpack_public_path__ + "static/img/mindex-5.790ccbb7.jpg";